import { productLocale, NotaryProduct } from '@ligo/bv-flow/store';
import { buildRule } from '@ligo/shared/mvc';
import { address } from '@ligo/bv-flow/store';

import {
  companyOtherQuestionsEnglishBV,
  detailsOfExistingCompany,
  bvDetailsOfNaturalPerson,
  detailsOfNewCompany,
  otherQuestions,
  otherQuestionsEnglishBV,
  addressCheckboxConfiguration
} from '@ligo/bv-flow/store';

export const identification = [
  ['nationality'],
  ['document_number'],
  ['bsn'],
  ['bsn_not_present']
];

const company_sections = [[['bv_type'], ...address]];

const customCompanyFields = (notary_product: NotaryProduct) => ({
  birthdate: {
    label: productLocale(
      notary_product,
      'shareholder.labels.representative_birthdate'
    )
  },
  birthplace: {
    label: productLocale(
      notary_product,
      'shareholder.labels.representative_birthplace'
    )
  },
  ...addressCheckboxConfiguration
});

const customNewCompanyQuestions = (notary_product: NotaryProduct) => ({
  company_name: {
    filter: (value: string) => {
      if (value) return value.replace(/(BV|B.V.)$/g, '').trim();
    },
    rules: [
      buildRule('bv_suffix', 'validations.bv_suffix'),
      buildRule('required', 'validations.required_generic')
    ],
    suffix: ' B.V.'
  },
  become_director: {
    label: productLocale(
      notary_product,
      'shareholder.labels.new_company_director'
    )
  },
  lives_in_netherlands: {
    label: productLocale(
      notary_product,
      'shareholder.labels.new_company_lives_in_netherlands'
    )
  },
  english_proficient: {
    label: productLocale(
      notary_product,
      'shareholder.labels.new_company_english_proficient'
    )
  },
  ...addressCheckboxConfiguration
});

const customNaturalPersonQuestions = (notary_product: NotaryProduct) => ({
  become_director: {
    label: productLocale(
      notary_product,
      'shareholder.labels.natural_person_director'
    )
  },
  lives_in_netherlands: {
    label: productLocale(
      notary_product,
      'shareholder.labels.natural_person_lives_in_netherlands'
    )
  },
  english_proficient: {
    label: productLocale(
      notary_product,
      'shareholder.labels.natural_person_english_proficient'
    )
  },
  pep : {
    label: productLocale(
        notary_product,
        'shareholder.labels.pep'
    )
  },
});

export const useSteps = (notary_product: NotaryProduct) => {
  const shareholderForms = [
    [
      {
        layout: bvDetailsOfNaturalPerson,
        sendStep: false,
        label: undefined,
        after_submit: undefined,
        sections: undefined,
        custom_fields: undefined
      },
      {
        layout: detailsOfExistingCompany,
        sendStep: false,
        label: undefined,
        after_submit: undefined,
        sections: {
          7: 'main_person'
        },
        custom_fields: customCompanyFields(notary_product)
      },
      {
        layout: detailsOfNewCompany,
        sendStep: false,
        label: undefined,
        after_submit: undefined,
        sections: {
          5: 'new_main_person'
        },
        custom_fields: customNewCompanyQuestions(notary_product)
      }
    ],
    [
      {
        layout: identification,
        sendStep: false,
        label: undefined,
        after_submit: undefined,
        sections: undefined,
        custom_fields: undefined
      },
      {
        layout: identification,
        sendStep: false,
        label: undefined,
        after_submit: undefined,
        sections: undefined,
        custom_fields: undefined
      },
      {
        layout: identification,
        sendStep: false,
        label: undefined,
        after_submit: undefined,
        sections: undefined,
        custom_fields: undefined
      }
    ],
    [
      {
        layout: otherQuestions,
        sendStep: false,
        label: undefined,
        after_submit: undefined,
        sections: undefined,
        custom_fields: customNaturalPersonQuestions(notary_product)
      },
      {
        layout: companyOtherQuestionsEnglishBV,
        sendStep: false,
        label: undefined,
        after_submit: undefined,
        sections: undefined,
        custom_fields: undefined
      },
      {
        layout: otherQuestionsEnglishBV,
        sendStep: false,
        label: undefined,
        after_submit: undefined,
        sections: undefined,
        custom_fields: undefined
      }
    ]
  ];
  const steps = [
    {
      name: 'generic-sections',
      props: {
        locale: 'company_name',
        sections: company_sections,
        resource: 'main'
      }
    },
    {
      name: 'shareholder-information',
      props: {
        shareholderForms: shareholderForms
      }
    },
    { name: 'holding-upsell' },
    { name: 'pie-chart' },
    { name: 'contract-upsell' },
    { name: 'dga' },
    { name: 'extra-services' },
    { name: 'preview-documents' }
  ];
  return { steps };
};
